import CtaButton from "./CtaButton";
import { useVariant } from "../context/VariantContext";

export default function Footer() {
  const { tagline, logoWhiteSvg, ctaHref, ctaBadge, ctaText, footer } = useVariant();
  return (
    <footer className="lp__footer">
      <div className="lp__footer-hero">
        <img
          className="lp__footer-hero__dog"
          src={footer.dogImage}
          alt={footer.dogImageAlt}
          width="576"
          height="576"
          loading="lazy"
        />
        <div className="lp__footer-hero__overlay">
          <p className="lp__footer-tagline">
            {tagline.map((line, i) => (
              <span key={i}>{i > 0 && <br />}{line}</span>
            ))}
          </p>
          <img
            className="lp__footer-logo"
            src={logoWhiteSvg}
            alt="たっぷ"
            width="173"
            height="69"
            loading="lazy"
          />
          <CtaButton href={ctaHref} badge={ctaBadge} text={ctaText} arrow trackLocation="footer" />
        </div>
      </div>

      <div className="lp__footer-info">
        <div className="lp__footer-info__inner">
          <p className="lp__footer-company">
            ぴちぴち株式会社
            <a
              href="https://pichipichi.co.jp/"
              target="_blank"
              rel="noopener noreferrer"
            >
              ↗ https://pichipichi.co.jp/
            </a>
          </p>
          <p className="lp__footer-address">
            〒669-2336
            <br />
            兵庫県丹波篠山市魚屋町14
          </p>
        </div>
      </div>

      <div className="lp__footer-legal">
        <a href="https://pichipichipet.web.app/terms" target="_blank" rel="noopener noreferrer">利用規約</a>
        <span className="lp__footer-legal__sep">|</span>
        <a href="https://pichipichipet.web.app/privacy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>
        <span className="lp__footer-legal__sep">|</span>
        <a href="https://pichipichipet.web.app/commercial-transactions" target="_blank" rel="noopener noreferrer">特定商取引法に基づく表記</a>
      </div>

      <div className="lp__footer-copyright">
        <p>{footer.copyright}</p>
      </div>
    </footer>
  );
}
